<template>
  <v-form v-model="valid">
    <section
      id="get-in-touch"
      class="hide-overflow"
    >
      <v-layout
        info
        white--text
      >
        <v-flex
          hidden-sm-and-down
          md6
        >
          <v-img
            :src="require('@/assets/contact.jpg')"
            height="100%"
          />
        </v-flex>
        <v-flex
          xs12
          md6
          pa-5
        >
          <base-bubble-1 />
          <base-heading class="mb-5">
            Get In Touch
          </base-heading>

        <base-text class="mb-5">
          Please contact us via email.
        </base-text>

          <!-- <v-sheet
            max-width="600"
            color="transparent"
          >
            <v-text-field
              v-model="name"
              color="info"
              label="Name"
              :rules="nameRules"
              required
              solo
              flat
            />
            <v-text-field
              v-model="email"
              color="info"
              label="Email"
              :rules="emailRules"
              required
              solo
              flat
            />
            <v-text-field
              v-model="subject"
              color="info"
              label="Subject"
              :rules="subjectRules"
              required
              solo
              flat
            />
            <v-textarea
              v-model="message"
              color="info"
              label="Message"
              :rules="messageRules"
              required
              solo
              flat
            />
            <v-btn
              color="success"
              :disabled="!valid"
              @click="sendEmail"
            >
              Send
            </v-btn>
          </v-sheet> -->
        </v-flex>
      </v-layout>
    </section>
  </v-form>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: false,
    name: '',
    nameRules: [
      v => !!v || 'Name is required'
    ],
    email: '',
    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    subject: '',
    subjectRules: [
      v => !!v || 'Subject is required'
    ],
    message: '',
    messageRules: [
      v => !!v || 'Message is required'
    ]
  }),
  methods: {
    sendEmail: function () {
      axios.post('https://asia-northeast1-freelance-st40pg.cloudfunctions.net/sendMail', {
        site: 'freelance-st40pg.firebaseapp.com',
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message
      })
        .then(response => {
          console.log(response.data)
          console.log(response.status)
          location.href = './contact-send.html'
        }).catch(error => {
          console.error(error)
          alert('Email transmission failed. Please submit again.')
        })
    }
    // sendEmail: () => {
    //   alert(message);
    // }
  }
}
</script>
